import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('rates_batch_draft_rate', 1)
const reducer = generator.generate()

export default reducer
